import { useContext } from 'react';

import { ExportSettingsContext } from '@/pages/DataHub/Export/ExportSettingsContext';

export const useExportSettingsContext = () => {
  const { exportSettings } = useContext(ExportSettingsContext);
  const { exportType, includeMetadata, from, to, period, periodNumber } = exportSettings;
  return { exportType, includeMetadata, from, to, period, periodNumber };
};
